import { Optimize, OptimizeProps } from '../Optimize';

export const OptimizeStep: React.FC<OptimizeProps> = ({
  onOptimizeSelected,
  optimization,
}) => {
  return (
    <Optimize
      onOptimizeSelected={onOptimizeSelected}
      optimization={optimization}
    />
  );
};
